import { Snapshot } from '@candu-ai/snapshots/types';

export const getLatestSnapshot = (snapshots: Snapshot[]) => {
  const sorted = snapshots.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );

  return sorted.length > 0 ? sorted[0] : undefined;
};
